/*
 * Управляет состоянием выбранного пользователем города
 */

import Vue from 'vue';

const _ = require('lodash');
const axios = require('axios');

// Приходит из конфигурации сервера
const CITIES_API_URL = citiesApiUrl;// eslint-disable-line

const selectedCity = Vue.observable({
  Name: null,
  Code: null,
  Confirmed: false,
});


export const getters = {
  name: () => selectedCity.Name,
  code: () => selectedCity.Code,
  confirmed: () => selectedCity.Confirmed,
};

export const actions = {
  validate(city) {
    if (typeof city.Name === 'undefined' || !city.Name) {
      throw new Error('Name field required');
    }
    if (typeof city.Code === 'undefined' || !city.Code) {
      throw new Error('Code field required');
    }
  },
  load() {
    try {
      const city = this.fetch();
      if (city) {
        return Promise.resolve(city);
      }
      return this.detect();
    } catch {
      return this.detect();
    }
  },
  fetch() {
    const city = JSON.parse(localStorage.getItem('userCity'));

    if (city) {
      this.validate(city);
    }

    return city;
  },
  persist() {
    localStorage.setItem('userCity', JSON.stringify(selectedCity));
  },
  detect() {
    return new Promise((resolve) => {
      function defaultCityFallback() {
        resolve({ Code: '16', Name: 'Екатеринбург' }); // Екатеринбург
      }

      axios
        .get(`${CITIES_API_URL}/detect`)
        .then((result) => {
          if (result && result.data) {
            try {
              const city = result.data;

              this.validate(city);

              resolve(_.pick(city, ['Code', 'Name']));
            } catch {
              defaultCityFallback();
            }
          } else {
            defaultCityFallback();
          }
        })
        .catch(() => {
          defaultCityFallback();
        });
    });
  },
};

export const mutations = {
  /**
   * @param {Object} city
   * @param {string} city.Name
   * @param {string} city.Code
   */
  setCity(city) {
    actions.validate(city);

    selectedCity.Name = city.Name;
    selectedCity.Code = city.Code;

    if (typeof city.Confirmed !== 'undefined') {
      selectedCity.Confirmed = !!city.Confirmed;
    }
  },
  confirm() {
    try {
      actions.validate(selectedCity);
    } catch {
      throw new Error('No city selected');
    }

    selectedCity.Confirmed = true;
  },
};
